import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export const TOGGLE_FILTER = 'filters/TOGGLE_FILTER'

export const FilterMobilitätsbehinderung = 'mobilitätsbehinderung'
export const FilterGehörlos = 'gehörlos'
export const FilterHörbehinderung = 'hörbehinderung'
export const FilterSehbehinderung = 'sehbehinderung'
export const FilterGeistigeBehinderung = 'geistigeBehinderung'

const initialState = [
    {
        filter: FilterMobilitätsbehinderung,
        isActive: false,
        icon: 'accessible',
        tooltip: 'Mobilitätsbehinderung'
    },
    {
        filter: FilterGehörlos,
        isActive: false,
        //icon: 'voice_over_off',
        icon: (
            <SvgIcon
                viewBox="0 0 34.092 32.961"
                style={{
                    width: 'auto',
                    margin: '.2rem',
                    height: 'auto'
                }}
            >
                <g transform="translate(-150.3 -132.2)">
                    <path d="m163.21 164.76c-0.42553-0.42554-0.21062-1.3819 0.40532-1.8037 0.20818-0.14255 1.7676-0.26162 3.4653-0.26459 1.8191-3e-3 3.0868-0.15028 3.0868-0.35818 0-0.21784-1.8304-0.35277-4.7857-0.35277-2.6321 0-5.0928-0.16434-5.468-0.36519-0.86294-0.46183-0.89223-1.9671-0.0471-2.4194 0.3494-0.18699 2.4925-0.34566 4.7625-0.35259 2.27-7e-3 4.286-0.0183 4.48-0.0252 0.19403-7e-3 0.35278-0.16742 0.35278-0.35664 0-0.20532-2.2961-0.38313-5.6947-0.44097-4.9751-0.0847-5.7438-0.17494-6.0836-0.7143-0.28343-0.44986-0.28342-0.78486 2e-5 -1.2347 0.34077-0.54085 1.1166-0.62935 6.26-0.71409 3.5158-0.0579 5.871-0.23482 5.871-0.44097 0-0.20672-1.8925-0.34425-4.7373-0.34425-3.8363 0-4.5408-0.20713-5.2917-0.47084-0.5137-0.31325-0.56271-0.47378-0.55436-1.0713 0.0158-1.1276 0.85177-1.2801 7.1555-1.2801 4.3526 0 6.2695-0.11789 6.1821-0.38022-0.0697-0.20912-1.0751-0.88381-2.2343-1.4993-1.8257-0.96947-2.1221-1.2692-2.2163-2.2422-0.15049-1.5535 0.79083-2.0444 2.6348-1.3742 2.9562 1.0744 9.7929 4.3793 10.921 5.2791 3.5205 2.8091 3.6432 8.3602 0.25583 11.575-1.9567 1.8571-2.9757 2.0472-10.975 2.0472-4.9612 0-7.4777-0.1286-7.7449-0.39577zm-6.6284-14.392c-2.6021-0.72199-2.9948-0.95408-2.9948-1.7702 0-1.3489 0.78279-1.4621 3.9963-0.578 1.8684 0.51406 3.1413 0.70816 3.2708 0.49874 0.11654-0.18856 0.1563-0.39209 0.0884-0.45228-0.0679-0.0602-2.2666-0.70121-4.886-1.4245-4.7488-1.3113-5.276-1.5834-5.2863-2.7282-0.0122-1.3722 1.1904-1.398 5.7124-0.12232 2.3841 0.67255 4.468 1.0896 4.6309 0.92666 0.42075-0.42075 0.26177-0.48021-5.3541-2.0027-5.3145-1.4408-5.7405-2.2727-5.3474-3.312 0.15573-0.41167 0.33097-0.74643 0.88253-0.70556 0.68507 0.0508 2.8256 0.64797 5.662 1.4399 4.7645 1.3303 6.0934 1.5084 5.25 0.70352-0.18109-0.17282-2.1437-0.79964-4.3613-1.3929-4.3475-1.1631-4.9921-1.4513-4.7454-2.7856 0.21055-0.33591 0.32415-0.84124 1.0524-0.70088 0.81608 0.15726 3.1302 0.60629 6.1376 1.4575 3.4936 0.98879 5.5954 1.4264 5.8208 1.2119 0.23018-0.21907-0.29328-0.90946-1.5063-1.9867-1.0758-1.2033-1.4294-1.5894-2.047-2.7088s0.85776-2.1342 1.804-1.5879 4.0539 2.7613 8.3829 6.465c1.1262 0.96346 2.3413 2.3276 2.7004 3.0315 0.80901 1.5858 1.2787 4.4458 0.78068 4.7536-0.19789 0.1223-1.6279-0.33518-3.1778-1.0166-3.1654-1.3918-3.5649-1.4502-4.9645-0.72645-1.8063 0.93406-2.2022 3.2907-0.81772 4.8673 0.51238 0.58349 0.32496 0.61736-3.4163 0.61736-2.1771 0-4.2258 0.13884-4.5526 0.30853-0.37537 0.19492-1.375 0.0919-2.7147-0.27983z" />
                </g>
            </SvgIcon>
        ),
        tooltip: 'Gehörlos'
    },
    {
        filter: FilterHörbehinderung,
        isActive: false,
        icon: 'hearing',
        tooltip: 'Schwerhörig'
    },
    {
        filter: FilterSehbehinderung,
        isActive: false,
        icon: 'visibility_off',
        tooltip: 'Blinde und Sehbehinderte'
    },
    {
        filter: FilterGeistigeBehinderung,
        isActive: false,
        icon: 'help',
        tooltip: 'geistig Behinderte und Menschen mit Demenz'
    }
]

export default (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_FILTER:
            return state.map(item => {
                if (item.filter !== action.filter) {
                    return item
                }

                return {
                    ...item,
                    isActive: !item.isActive
                }
            })

        default:
            return state
    }
}

export const toggleFilter = filter => {
    return dispatch => {
        dispatch({
            type: TOGGLE_FILTER,
            filter
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/filters.js